<script setup lang="ts">
import type { IconSize } from '@consumer/components/GIcon.vue'
import { faXmark } from '@fortawesome/pro-light-svg-icons'

const { size = 'md' } = defineProps<{ size?: IconSize }>()
</script>

<template>
  <button type="button" class="flex items-center justify-center text-v2-tertiary py-1 hover:text-navy">
    <GIcon :icon="faXmark" :size="size"/>
  </button>
</template>
